import React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  id: string;
  value: string;
}

/**
 * Used to hold the contents of tabs.
 */
export function TabPanel(props: TabPanelProps) {
  const { children, value, id, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== id} id={id} aria-labelledby={id} {...other}>
      {value === id && <div>{children}</div>}
    </div>
  );
}
